/**
 * Adds a displayName field to each envio object in the envios array, taking the displayName
 * from the corresponding user object in the users array.
 *
 * @param {Array} envios - An array of envio objects, each with a user_id field.
 * @param {Array} users - An array of user objects, each with an id and displayName field.
 * @returns {Array} - A new array of envio objects with an added displayName field
 *                   where a matching user is found.
 */
export function addDisplayNameToEnvios(envios, users) {
  // Create a lookup object with user IDs as keys and display names as values
  const userLookup = users.reduce((acc, user) => {
    acc[user.id] = user.displayName;
    return acc;
  }, {});

  // Use the map function to create a new array of envio objects with the added displayName field
  return envios.map((envio) => {
    const displayName = userLookup[envio.user_id];

    // If a matching user is found, add the displayName field to the envio object
    if (displayName) {
      return {
        ...envio,
        displayName
      };
    }

    // If no matching user is found, return the original envio object without the displayName field
    return envio;
  });
}
